{
  "comment": "M7 spec §2.1–§2.2 (S2 owns): the evacuation thread's logs. Log shape: src/story/schemas.ts evidenceLogSchema (at most ~120 words or one table; form carries the fact). Ids are unique across every evidence file; this file's ids start 'evacuation.'. Fixed first-hour hook (spec §2.2, S14 reads it by id): 'evacuation.harrow_queue' is the first core salvaged at the Harrow POI (a Gate Control transmission cut off mid-sentence). 'evacuation.c9_decode' is the decode return that opens Mission 1 (fromTier 2; lead 'column-nine'). 'evacuation.column_nine_queue' is the Column Nine recorder's log (item column_nine_recorder; PC-1 frame serial T-0388 must match the M2 ship-screen serial seed; PC-8 OPS-R/7, never Voss's name before tier 4). Lead systemHints (resolved by the integration lane): 'column-nine' (the M1 field), 'convoy-wrecks' (any old convoy wreck field), 'fr-colony' (any First Rush colony ruin), plus galaxy anchor kinds. Claim words added here (tier 2 slots): durations '11_days', '9_days', '3_days'; hulls 'settler_ships', 'ore_haulers', 'kt3_escorts'; verbs 'held_in_queue', 'cleared_through'; tier 5: 'natural_event', 'natural_cycle', 'gate_fault', 'tethys'; tier 4: 'ops_r7'. Every name, hull code, place and date (CY = Charter Year; the Collapse is CY10 d200–d210) is a placeholder until the naming pass. Canon guards (first-rush.md §6, §9): no conclusion stated, no counters, no Voss before tier 4, no Rush-pattern parts, no 'stripped the gate'. Repeatable corroboration (spec §2.5, the order link): 'evacuation.corr_insurance_claim' is the Mutual archivist's pull of an insurance claim on a Column Nine settler hull (fee); a template, slots {policy}, {hull}, {claimant}, {day} filled from a seed.",
  "logs": [
    {
      "id": "evacuation.harrow_queue",
      "thread": "evacuation",
      "link": "order",
      "kind": "proof",
      "weight": 1,
      "title": "Gate Control broadcast, fragment",
      "date": "CY10 d208, 05:58",
      "source": "derelictCore",
      "body": "REACH GATE CONTROL TO ALL HULLS HOLDING AT THE GATE. Gate event, day 9. Revised order follows, effective 06:00, authority OPS-R/7. Carriers TH-0417, TH-0233, TH-0460, TH-0586 with escorts: proceed to marker one. SL Marrow Bay, SL Oriel Sound, Column Nine convoy: hold at marker nine. Repeat, hold at marker nine. Transit windows remaining, estimate six. Column Nine, your lead hull is closing on the lane. Wendell Pike, acknowledge. Wendell Pike, you are drifting into the carrier lane. Back off now or we will",
      "words": ["9_days", "ore_haulers", "settler_ships", "held_in_queue"]
    },
    {
      "id": "evacuation.liner_log",
      "thread": "evacuation",
      "link": "order",
      "kind": "proof",
      "weight": 1,
      "title": "SL Oriel Sound, bridge log extract",
      "date": "CY10 d200 to d210",
      "source": "convoyWreck",
      "body": "Bridge log, settler liner Oriel Sound, 1,180 aboard. Queue position as posted by Gate Control at 06:00 each day. Kept by the second officer.",
      "table": {
        "columns": ["Day", "Queue position", "Order signed", "Note"],
        "rows": [
          ["d200", "6", "GC", "Boarding closed. Gate flickered twice."],
          ["d202", "7", "GC", "Carrier went ahead of us. Cargo not stated."],
          ["d204", "9", "GC", "Two more carriers ahead."],
          ["d206", "11", "OPS-R/7", "Order now signed OPS-R/7. Captain called Gate Control. No answer."],
          ["d208", "13", "OPS-R/7", "Water to 2 l a head."],
          ["d210", "13", "OPS-R/7", "Gate dark 04:12. Eleventh day. Holding at marker nine."]
        ]
      },
      "words": ["11_days", "settler_ships", "held_in_queue"]
    },
    {
      "id": "evacuation.th0417_manifest",
      "thread": "evacuation",
      "link": "order",
      "kind": "proof",
      "weight": 1,
      "title": "Hauler TH-0417, outbound manifest (Gate Control transit file)",
      "date": "CY10 d208",
      "source": "derelictCore",
      "body": "Gate Control transit file, copy filed at clearance. Cleared through the gate CY10 d208 at 06:14.",
      "table": {
        "columns": ["Hold", "Contents", "Quantity", "Note"],
        "rows": [
          ["1", "FC-6 fracture crystalline", "1,180 t", "sealed"],
          ["2", "FC-6 fracture crystalline", "1,140 t", "sealed"],
          ["3", "Persons, non-crew", "212", "waiver 10-208-3. Carrow ring. Water 3 days. Air: hold scrubber only."],
          ["Crew", "", "14", ""],
          ["Waiver", "authorised", "OPS-R/7", ""],
          ["Proceeds, holds 1-2", "15% to Evacuation Charter Fund", "", "standing order R/7-3"],
          ["Purser", "", "", "Hold 3 is not rated for persons."]
        ]
      },
      "words": ["ore_haulers", "cleared_through", "3_days"]
    },
    {
      "id": "evacuation.column_nine_queue",
      "thread": "evacuation",
      "link": "order",
      "kind": "proof",
      "weight": 3,
      "title": "Column Nine flight recorder: queue log",
      "date": "CY10 d209, 06:00",
      "source": "missionItem",
      "item": "column_nine_recorder",
      "fromTier": 2,
      "body": "Flight recorder, SL Wendell Pike, lead hull of Column Nine: 7 hulls, 4,310 aboard. Gate Control's last order board received before loss of signal. Master's note: held at marker nine since d203. Slot number raised four times.",
      "table": {
        "columns": ["Pos", "Hull", "Class", "Signed"],
        "rows": [
          ["1", "TH-0460", "ore carrier", "OPS-R/7"],
          ["2", "KT-3, frame T-0388", "escort, TH-0460", "OPS-R/7"],
          ["3", "TH-0586", "ore carrier", "OPS-R/7"],
          ["4", "KT-3, frame T-0157", "escort, TH-0586", "OPS-R/7"],
          ["5", "TH-0478", "ore carrier", "OPS-R/7"],
          ["6", "SL Marrow Bay", "settler liner", "GC"],
          ["7 to 13", "7 hulls incl. SL Oriel Sound", "settler liners", "GC"],
          ["14", "SL Wendell Pike and 6 hulls (Column Nine)", "settler liners", "GC"],
          ["Windows remaining", "6 (est.)", "", ""]
        ]
      },
      "words": ["settler_ships", "ore_haulers", "kt3_escorts", "held_in_queue", "ops_r7"]
    },
    {
      "id": "evacuation.column_nine_roll",
      "thread": "evacuation",
      "link": "none",
      "kind": "texture",
      "weight": 0,
      "title": "Column Nine flight recorder: column roll",
      "date": "CY10 d208, 05:41",
      "source": "missionItem",
      "body": "SL Wendell Pike, column roll, persons aboard at seal.\nd208 05:41, master H. Duarte, SL Corrie Dane, for the column: request slot, 4,310 aboard, water 4 days.\nd208 05:44, Gate Control: Request noted. Column Nine holds at marker nine. Thank you for your patience.",
      "table": {
        "columns": ["Hull", "Class", "Aboard", "Note"],
        "rows": [
          ["SL Wendell Pike", "settler liner", "1,020", "lead"],
          ["SL Lanyard", "settler liner", "840", ""],
          ["SL Corrie Dane", "settler liner", "610", "slot request d208"],
          ["SL Saltmarsh", "settler liner", "560", "TCF lease band, cream"],
          ["SL Amberly", "settler liner", "480", ""],
          ["SL Tamsin Wake", "settler tender", "430", ""],
          ["SL Calder Moor", "settler tender", "370", ""],
          ["Column Nine", "7 hulls", "4,310", ""]
        ]
      },
      "item": "column_nine_recorder",
      "fromTier": 2
    },
    {
      "id": "evacuation.c9_decode",
      "thread": "evacuation",
      "link": "none",
      "kind": "lead",
      "weight": 0,
      "title": "Mutual archive, decode return",
      "date": "CY60",
      "source": "mutualArchive",
      "fromTier": 2,
      "body": "SPACERS' MUTUAL ARCHIVE. DECODE RETURN. Request: Gate Control queue fragment, Harrow core. Result: board matched to the day 9 post. Column Nine lead hull SL Wendell Pike: transponder last fix CY10 d214, deep region, 7 hulls in line, drives cold. No salvage has been filed on that fix in fifty years. Fix attached. No fee on this one.",
      "lead": { "systemHint": "column-nine", "poiKind": "wreckField" }
    },
    {
      "id": "evacuation.beacon_relay",
      "thread": "evacuation",
      "link": "none",
      "kind": "lead",
      "weight": 0,
      "title": "FR-217 Harrow, beacon relay call log",
      "date": "CY10 d210 to d216",
      "source": "derelictCore",
      "body": "Distress calls relayed by the Harrow mast beacon after the gate went dark. Relay kept running on station power.",
      "table": {
        "columns": ["Day", "Hull", "Call", "Last fix"],
        "rows": [
          ["d210", "SL Oriel Sound", "water, 1,180 aboard", "marker nine"],
          ["d211", "TH-0502", "drive fault, 9 crew", "Tollen Drift approach"],
          ["d212", "SL Brannock", "air, hull breach, deck 3", "Tollen Drift approach"],
          ["d214", "SL Wendell Pike", "no call, transponder only", "deep region"],
          ["d216", "relay", "no further calls", ""]
        ]
      },
      "lead": { "systemHint": "convoy-wrecks", "poiKind": "wreckField" }
    },
    {
      "id": "evacuation.lifeboat_log",
      "thread": "evacuation",
      "link": "none",
      "kind": "lead",
      "weight": 0,
      "title": "SL Oriel Sound, boat launch log",
      "date": "CY10 d221",
      "source": "convoyWreck",
      "body": "Boats away for the hab ring at Tollen Drift, 19 days under drive.",
      "table": {
        "columns": ["Boat", "Aboard", "Status"],
        "rows": [
          ["1", "38", "launched 07:10"],
          ["2", "41", "launched 07:25"],
          ["3", "0", "seal fault, not launched"],
          ["4", "40", "launched 08:02"],
          ["Liner", "1,061", "master remains. Scrubbers on 2 of 6 units."]
        ]
      },
      "lead": { "systemHint": "fr-colony", "poiKind": "ruin" }
    },
    {
      "id": "evacuation.gate_control_notice",
      "thread": "evacuation",
      "link": "none",
      "kind": "official",
      "weight": 0,
      "title": "Gate Control public notice 10-210",
      "date": "CY10 d210, 04:30",
      "source": "derelictCore",
      "body": "REACH GATE CONTROL. PUBLIC NOTICE 10-210. Transit ceased at 04:12. Over 11 days, Gate Control cleared 41 hulls through the gate in posted order under Charter emergency rules. Cause: gate fault or field event, under survey. Hulls in queue: hold position, conserve air and water, await contact. Settlements: keep operations working. Gate Control thanks every crew for their patience.",
      "words": ["11_days", "cleared_through", "gate_fault"]
    },
    {
      "id": "evacuation.survey_bulletin_11",
      "thread": "evacuation",
      "link": "none",
      "kind": "official",
      "weight": 0,
      "title": "Tethys Survey Bulletin 11",
      "date": "CY10 d262",
      "source": "derelictCore",
      "body": "TETHYS MINING COMBINE. SURVEY BULLETIN 11. Finding: the cessation of transit on CY10 d210 was a natural event, consistent with a natural cycle in the gate field. Extraction volumes at Carrow in the period were within plan and bear no relation to transit. All Tethys carriers in the queue moved under posted Gate Control order. Distribution: Charter Commission; Gate Control; staff notice boards, all sites.",
      "words": ["natural_event", "natural_cycle", "tethys"]
    },
    {
      "id": "evacuation.last_message",
      "thread": "evacuation",
      "link": "none",
      "kind": "texture",
      "weight": 0,
      "title": "Outbound message, not sent",
      "date": "CY10 d209",
      "source": "convoyWreck",
      "body": "SL Oriel Sound, cabin 4-112. Message queued for transmission through the gate. Dee. Still at the gate. Ninth day. They keep moving us back a marker, so we keep repacking the bags. The kids made a league out of the deck plates and Tam is winning, he cheats. If this gets through before we do, tell Mum we're coming home after all. Don't sell the bench. J. STATUS: QUEUED. RETRIES: 0."
    },
    {
      "id": "evacuation.shift_note",
      "thread": "evacuation",
      "link": "none",
      "kind": "texture",
      "weight": 0,
      "title": "TH-0502, pilot's shift note",
      "date": "CY10 d207",
      "source": "convoyWreck",
      "body": "Shift 3, R. Amsel. Slot at 06:10 scrubbed again; drive's coughing and Dispatch won't sign the fault. Dispatch wants the tonnage logged before every slot. Logged 1,160 t. Ate. Slept four hours. A liner sits on the next marker, the Oriel something. Kids at the big window all morning, waving at us. Waved back. Told Mira on the comm it's just rocks in the hold. She laughed. Don't know why."
    },
    {
      "id": "evacuation.scrubber_rota",
      "thread": "evacuation",
      "link": "none",
      "kind": "texture",
      "weight": 0,
      "title": "Scratched inside a scrubber housing",
      "date": "Year 3 (we think)",
      "source": "derelictCore",
      "body": "Hab ring, Tollen Drift. SCRUBBER 2. NIGHT ROTA. DO NOT SKIP YOUR NIGHT. 1: Pell and L. Duarte. 2: Asha (the other Asha, not the baby). 3: Grieve twins. 4: Nan if her chest is ok, else me. M. 5: Pell. Filter paper left: 9 sheets. Cut them in half from now on. Whoever took the red flask, it's Nan's. Bring it back. No questions. Kids: stop betting ration squares on the Candle."
    },
    {
      "id": "evacuation.corr_insurance_claim",
      "thread": "evacuation",
      "link": "order",
      "kind": "proof",
      "weight": 1,
      "title": "Insurance claim, certified copy",
      "date": "CY10",
      "source": "mutualArchive",
      "fromTier": 2,
      "body": "SPACERS' MUTUAL ARCHIVE · INSURANCE CLAIM, CERTIFIED COPY\nPolicy: {policy}, settler liner {hull}\nClaimant: {claimant}, for the family\nLoss: hull and persons. Held at marker nine from CY10 d{day}. Not cleared through before the gate went dark.\nUnderwriter's note: carrier hulls on the same board cleared under OPS-R/7. Claim declined: natural event.\nPulled from the archive's insurance stacks. Fee paid.",
      "repeatable": true,
      "template": true
    }
  ]
}
